import React, { useEffect, useState, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  FaBell, FaHome, FaClipboardList, FaDollarSign, FaCheckCircle,
  FaChartLine, FaFileAlt, FaCog, FaQuestionCircle,
  FaEdit, FaToggleOff, FaSignOutAlt, FaChevronDown,
  FaHardHat, FaBars, FaTimes, FaUsers, FaShieldAlt,
  FaHeadset, FaUserCog, FaExclamationTriangle, FaBox,
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import api from "../../api/axiosClient";
import CraftsmenTable      from '../components/CraftsmenTable';
import CraftsmandetailViewPage from '../components/CraftsmandetailViewPage';
import JobRequests         from '../components/JobRequests';
import PaymentDashboard    from '../components/AdminPaymentDashboard';
import RejectModal         from '../components/RejectModal';
import AnalyticsPage       from '../components/AnalyticsPage';
import ReportsPage         from '../components/ReportsPage';
import SupportPage         from '../components/SupportPage';
import SettingsPage        from '../components/SettingsPage';
import ProductPage        from '../components/ProductPage'; // ← the full pending/approved/rejected/security product UI
import { getFullImageUrl } from "../../utils/getFullImageUrl";
import kaakaziniLogo        from "../../assets/kazini.png"; // ← same logo used on AdminLoginPage

/* ═══════════════════════════════════════════════════════
   THEME — Raleway · Yellow #fff000 · Black · White
═══════════════════════════════════════════════════════ */
const THEME = `
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700;800;900&display=swap');

:root {
  --blk:  #000000;
  --drk:  #0a0a0a;
  --srf:  #111111;
  --crd:  #141414;
  --crd2: #1a1a1a;
  --bdr:  rgba(255,255,255,.08);
  --bdr2: rgba(255,255,255,.16);
  --gld:  #fff000;
  --gld2: #e6d900;
  --gld3: rgba(255,240,0,.08);
  --wht:  #ffffff;
  --txt:  #ffffff;
  --txt2: #cccccc;
  --txt3: #888888;
  --sid:  264px;
  --top:  64px;
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html, body, #root { background: var(--blk); }

::-webkit-scrollbar { width: 4px; height: 4px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: rgba(255,255,255,.12); border-radius: 4px; }

.adm {
  font-family: 'Raleway', sans-serif;
  background: var(--blk);
  color: var(--txt);
  min-height: 100vh;
  display: flex;
}

/* SIDEBAR */
.sb {
  width: var(--sid);
  min-height: 100vh;
  background: var(--drk);
  border-right: 1px solid var(--bdr);
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0; left: 0;
  z-index: 300;
  transition: width .28s cubic-bezier(.4,0,.2,1), transform .28s cubic-bezier(.4,0,.2,1);
  overflow: hidden;
}
.sb.col { width: 68px; }
.sb.mh  { transform: translateX(-100%); }
.sb.ms  { transform: translateX(0) !important; }

.sb-logo { display: flex; align-items: center; gap: 11px; padding: 0 1.125rem; height: var(--top); border-bottom: 1px solid var(--bdr); flex-shrink: 0; }
.sb-gem { width: 36px; height: 36px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
.sb-gem img { width: 100%; height: 100%; object-fit: contain; }
.sb-brand { font-weight: 800; font-size: 1rem; color: var(--txt); white-space: nowrap; transition: opacity .2s, transform .2s; }
.sb-brand em { color: var(--gld); font-style: normal; }
.sb.col .sb-brand { opacity: 0; transform: translateX(-8px); pointer-events: none; }

.sb-nav { flex: 1; overflow-y: auto; overflow-x: hidden; padding: .75rem .625rem; -webkit-overflow-scrolling: touch; }
.sb-section { font-size: .58rem; font-weight: 800; letter-spacing: .14em; text-transform: uppercase; color: var(--txt3); padding: .625rem .5rem .375rem; white-space: nowrap; transition: opacity .2s; }
.sb.col .sb-section { opacity: 0; }

.sb-btn { width: 100%; border: none; background: transparent; color: var(--txt3); display: flex; align-items: center; gap: 10px; padding: .5rem .625rem; border-radius: 10px; font-size: .84rem; font-weight: 500; cursor: pointer; transition: background .15s, color .15s; text-align: left; white-space: nowrap; margin-bottom: 2px; position: relative; min-height: 38px; }
.sb-btn:hover { background: rgba(255,255,255,.05); color: var(--txt); }
.sb-btn.on { background: rgba(255,240,0,.1); color: var(--gld); font-weight: 700; }
.sb-btn.on::before { content: ''; position: absolute; left: 0; top: 20%; bottom: 20%; width: 3px; border-radius: 0 3px 3px 0; background: var(--gld); }
.sb-btn .sb-ic { flex-shrink: 0; width: 16px; font-size: .88rem; }
.sb-btn .sb-lbl { flex: 1; transition: opacity .2s; }
.sb.col .sb-btn .sb-lbl { opacity: 0; width: 0; overflow: hidden; }

.sb-badge { background: var(--gld); color: #000000; border-radius: 50px; font-size: .6rem; font-weight: 800; padding: 2px 6px; flex-shrink: 0; transition: opacity .2s; min-width: 18px; text-align: center; }
.sb.col .sb-badge { opacity: 0; }

.sb-foot { padding: .875rem 1rem; border-top: 1px solid var(--bdr); display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
.sb-av { width: 34px; height: 34px; flex-shrink: 0; background: var(--gld); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: .82rem; color: #000000; }
.sb-info { flex: 1; min-width: 0; transition: opacity .2s; overflow: hidden; }
.sb.col .sb-info { opacity: 0; width: 0; }
.sb-name { font-size: .82rem; font-weight: 700; color: var(--txt); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sb-role { font-size: .68rem; color: var(--txt3); }
.sb-logout { background: none; border: none; color: var(--txt3); cursor: pointer; padding: 6px; border-radius: 8px; font-size: .85rem; transition: all .15s; flex-shrink: 0; }
.sb-logout:hover { color: var(--wht); background: rgba(255,255,255,.1); }

.rpill { display: inline-flex; align-items: center; gap: 4px; border-radius: 20px; padding: 2px 8px; font-size: .58rem; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; }
.rpill-superadmin  { background: rgba(255,240,0,.14); color: #fff000; border: 1px solid rgba(255,240,0,.3); }
.rpill-moderator   { background: rgba(255,255,255,.1); color: #ffffff; border: 1px solid rgba(255,255,255,.25); }
.rpill-maintenance { background: rgba(255,255,255,.06); color: #cccccc; border: 1px solid rgba(255,255,255,.16); }
.rpill-support     { background: rgba(255,240,0,.08); color: #fff000; border: 1px solid rgba(255,240,0,.2); }
.rpill-finance     { background: rgba(255,255,255,.08); color: #ffffff; border: 1px solid rgba(255,255,255,.2); }
.rpill-analytics   { background: rgba(255,240,0,.06); color: #e6d900; border: 1px solid rgba(255,240,0,.16); }

/* MAIN */
.mn { margin-left: var(--sid); flex: 1; display: flex; flex-direction: column; transition: margin-left .28s cubic-bezier(.4,0,.2,1); min-width: 0; min-height: 100vh; }
.mn.col { margin-left: 68px; }

.tb { height: var(--top); background: var(--drk); border-bottom: 1px solid var(--bdr); display: flex; align-items: center; gap: 12px; padding: 0 1.5rem; position: sticky; top: 0; z-index: 200; flex-shrink: 0; }
.tb-toggle { width: 34px; height: 34px; background: rgba(255,255,255,.05); border: 1px solid var(--bdr); border-radius: 9px; display: flex; align-items: center; justify-content: center; color: var(--txt2); cursor: pointer; transition: all .15s; flex-shrink: 0; }
.tb-toggle:hover { background: rgba(255,255,255,.09); color: var(--txt); }
.tb-title { flex: 1; min-width: 0; font-size: .95rem; font-weight: 800; color: var(--txt); letter-spacing: -.2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tb-title em { color: var(--gld); font-style: normal; }
.tb-actions { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }

.tb-bell { width: 34px; height: 34px; background: rgba(255,255,255,.05); border: 1px solid var(--bdr); border-radius: 9px; display: flex; align-items: center; justify-content: center; color: var(--txt2); cursor: pointer; position: relative; transition: all .15s; flex-shrink: 0; }
.tb-bell:hover { color: var(--gld); border-color: rgba(255,240,0,.3); }
.tb-bell-dot { position: absolute; top: 7px; right: 7px; width: 7px; height: 7px; border-radius: 50%; background: var(--gld); border: 1.5px solid var(--drk); }

.tb-user { display: flex; align-items: center; gap: 8px; background: rgba(255,255,255,.05); border: 1px solid var(--bdr); border-radius: 50px; padding: 4px 10px 4px 4px; cursor: pointer; transition: all .15s; position: relative; }
.tb-user:hover { border-color: rgba(255,240,0,.3); background: rgba(255,240,0,.06); }
.tb-user-av { width: 26px; height: 26px; flex-shrink: 0; background: var(--gld); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: .7rem; font-weight: 800; color: #000000; }
.tb-user-name { font-size: .8rem; font-weight: 600; color: var(--txt); }

.ddrop { position: absolute; top: calc(100% + 8px); right: 0; min-width: 200px; max-width: calc(100vw - 2rem); background: var(--crd2); border: 1px solid var(--bdr2); border-radius: 14px; box-shadow: 0 20px 60px rgba(0,0,0,.7); z-index: 9999; overflow: hidden; animation: ddIn .15s ease; }
@keyframes ddIn { from { opacity:0; transform:translateY(-6px) scale(.97) } to { opacity:1; transform:translateY(0) scale(1) } }
.ddrop-head { padding: .875rem 1rem; border-bottom: 1px solid var(--bdr); }
.ddrop-head .ddn { font-weight: 700; font-size: .84rem; color: var(--txt); }
.ddrop-head .dde { font-size: .72rem; color: var(--txt3); margin-top: 1px; word-break: break-all; }
.ddrop-item { width: 100%; background: none; border: none; padding: .65rem 1rem; display: flex; align-items: center; gap: 9px; font-size: .82rem; color: var(--txt2); cursor: pointer; text-align: left; transition: background .12s, color .12s; }
.ddrop-item:hover { background: rgba(255,255,255,.06); color: var(--txt); }
.ddrop-item.danger:hover { background: rgba(255,255,255,.1); color: var(--wht); font-weight: 700; }
.ddrop-div { border-top: 1px solid var(--bdr); margin: 0; }

.ct { flex: 1; padding: 1.75rem 1.75rem 3rem; overflow-y: auto; overflow-x: hidden; min-width: 0; }
.pg-head { margin-bottom: 1.5rem; }
.pg-title { font-size: 1.4rem; font-weight: 800; color: var(--txt); margin-bottom: 2px; letter-spacing: -.3px; }
.pg-title em { color: var(--gld); font-style: normal; }
.pg-sub { font-size: .82rem; color: var(--txt3); }

.stat-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; margin-bottom: 1.5rem; }
.stat-card { background: var(--crd); border: 1px solid var(--bdr); border-radius: 16px; padding: 1.25rem 1.375rem; display: flex; justify-content: space-between; align-items: flex-start; cursor: pointer; position: relative; overflow: hidden; transition: transform .2s, border-color .2s, box-shadow .2s; min-width: 0; }
.stat-card::after { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px; background: var(--card-accent, var(--gld)); }
.stat-card:hover { transform: translateY(-3px); border-color: rgba(255,240,0,.25); box-shadow: 0 10px 30px rgba(0,0,0,.5); }
.sc-label { font-size: .68rem; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; color: var(--txt3); margin-bottom: 8px; overflow-wrap: break-word; }
.sc-val { font-size: 2rem; font-weight: 800; line-height: 1; color: var(--card-accent, var(--gld)); }
.sc-delta { font-size: .72rem; color: var(--txt3); margin-top: 5px; }
.sc-delta.up { color: var(--gld); }
.sc-icon { width: 42px; height: 42px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 1rem; flex-shrink: 0; background: var(--card-icon-bg, rgba(255,240,0,.08)); color: var(--card-accent, var(--gld)); }

.glass { background: var(--crd); border: 1px solid var(--bdr); border-radius: 16px; overflow: hidden; min-width: 0; }
.glass-h { padding: 1rem 1.375rem; border-bottom: 1px solid var(--bdr); display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.glass-t { font-size: .9rem; font-weight: 800; color: var(--txt); flex: 1; }
.glass-b { padding: 1.125rem 1.375rem; }

.act-row { display: flex; gap: 12px; padding: .75rem 0; border-bottom: 1px solid var(--bdr); }
.act-row:last-child { border-bottom: none; }
.act-dot { width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: .7rem; flex-shrink: 0; }
.act-label { font-size: .82rem; font-weight: 600; color: var(--txt); margin-bottom: 2px; overflow-wrap: break-word; }
.act-time { font-size: .7rem; color: var(--txt3); }
.act-chip { display: inline-flex; align-items: center; padding: 2px 7px; border-radius: 20px; font-size: .62rem; font-weight: 700; margin-left: 6px; }

.qa-btn { width: 100%; background: rgba(255,255,255,.04); border: 1px solid var(--bdr); color: var(--txt2); border-radius: 10px; padding: .7rem 1rem; display: flex; align-items: center; gap: 10px; font-size: .83rem; font-weight: 600; cursor: pointer; transition: all .15s; text-align: left; }
.qa-btn:hover { border-color: rgba(255,240,0,.25); color: var(--gld); background: rgba(255,240,0,.04); }

.rev-row { display: flex; justify-content: space-between; gap: 8px; padding: .5rem 0; border-bottom: 1px solid rgba(255,255,255,.05); }
.rev-row:last-child { border-bottom: none; }

.btn-gld { display: inline-flex; align-items: center; gap: 6px; background: var(--gld); color: #000000; border: none; border-radius: 9px; padding: .6rem 1.25rem; font-size: .84rem; font-weight: 700; cursor: pointer; transition: all .2s; box-shadow: 0 3px 12px rgba(255,240,0,.25); }
.btn-gld:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(255,240,0,.4); }

.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.85); z-index: 1000; }
.modal-box { position: fixed; top: 50%; left: 50%; transform: translate(-50%,-50%); width: min(500px, 95vw); max-height: 90vh; display: flex; flex-direction: column; background: var(--crd); border: 1px solid var(--bdr2); border-radius: 18px; z-index: 1001; overflow: hidden; box-shadow: 0 32px 80px rgba(0,0,0,.8); }
.modal-head { padding: 1.1rem 1.5rem; border-bottom: 1px solid var(--bdr); background: rgba(255,240,0,.05); display: flex; align-items: center; justify-content: space-between; flex-shrink: 0; }
.modal-head-title { font-weight: 800; font-size: .92rem; color: var(--txt); display: flex; align-items: center; gap: 8px; }
.modal-close { background: none; border: none; color: var(--txt3); cursor: pointer; font-size: 1rem; }
.modal-body { padding: 1.25rem 1.5rem; display: flex; flex-direction: column; gap: 12px; overflow-y: auto; }
.modal-foot { padding: .875rem 1.5rem; border-top: 1px solid var(--bdr); display: flex; justify-content: flex-end; gap: 10px; background: rgba(255,255,255,.02); flex-shrink: 0; flex-wrap: wrap; }

.minp { width: 100%; background: var(--srf); border: 1.5px solid var(--bdr2); border-radius: 9px; padding: .65rem 1rem; color: var(--txt); font-size: .88rem; outline: none; transition: border-color .2s; }
.minp:focus { border-color: var(--gld); }
.mlabel { font-size: .68rem; font-weight: 700; color: var(--txt3); letter-spacing: .08em; text-transform: uppercase; display: block; margin-bottom: 5px; }

.infobanner { background: rgba(255,240,0,.06); border: 1px solid rgba(255,240,0,.2); border-radius: 12px; padding: .875rem 1.125rem; margin-bottom: 1.25rem; display: flex; align-items: flex-start; gap: 10px; font-size: .82rem; color: #fff000; }
.errbanner { background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.2); border-radius: 12px; padding: .875rem 1.125rem; margin-bottom: 1.25rem; display: flex; align-items: center; gap: 10px; font-size: .84rem; color: #ffffff; flex-wrap: wrap; }

.access-denied { text-align: center; padding: 5rem 2rem; }
.access-denied .lock-icon { font-size: 3rem; margin-bottom: 1rem; }
.access-denied h4 { font-weight: 800; color: var(--txt); margin-bottom: 8px; }
.access-denied p { color: var(--txt3); font-size: .88rem; }

.mob-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.75); z-index: 299; }

/* ═══════════════════════════════════════════════════════
   RESPONSIVE
═══════════════════════════════════════════════════════ */
@media (max-width: 1100px) {
  .stat-grid { grid-template-columns: repeat(2,1fr); }
}

@media (max-width: 768px) {
  .sb { width: 264px !important; transform: translateX(-100%); }
  .mn { margin-left: 0 !important; }
  .ct { padding: 1rem 1rem 2.5rem; }
  .tb { padding: 0 1rem; gap: 8px; }
  .tb-title { font-size: .86rem; }
  .stat-grid { grid-template-columns: repeat(2,1fr); gap: .75rem; }
  .stat-card { padding: 1rem 1.1rem; }
  .sc-val { font-size: 1.6rem; }
  .sc-icon { width: 36px; height: 36px; font-size: .88rem; }
  .pg-title { font-size: 1.2rem; }
  .glass-h { padding: .875rem 1rem; }
  .glass-b { padding: 1rem; }
  .modal-box { width: 92vw; max-height: 85vh; }
  .modal-head, .modal-body, .modal-foot { padding-left: 1.1rem; padding-right: 1.1rem; }
  .modal-foot { flex-direction: column-reverse; }
  .modal-foot button { width: 100%; justify-content: center; }
}

@media (max-width: 560px) {
  .stat-grid { grid-template-columns: 1fr 1fr; gap: .625rem; }
  .stat-card { padding: .875rem 1rem; flex-direction: column; gap: .5rem; }
  .sc-icon { order: -1; }
  .sc-val { font-size: 1.4rem; }
  .tb-user-name { display: none !important; }
  .tb-user { padding: 4px; }
  .pg-sub { font-size: .78rem; }
  .act-row { gap: 8px; }
  .ddrop { min-width: 180px; }
}

@media (max-width: 400px) {
  .stat-grid { grid-template-columns: 1fr; }
  .ct { padding: .75rem .75rem 2rem; }
  .tb { padding: 0 .75rem; }
}
`;

/* ═══════════════════════════════════════════════════════
   ROLE CONFIG
═══════════════════════════════════════════════════════ */
const ROLE_PERMISSIONS = {
  superadmin:  ['dashboard','craftsmen','jobs','payments','reports','analytics','support','settings','products'],
  moderator:   ['dashboard','craftsmen','support','products'],
  maintenance: ['dashboard','jobs'],
  support:     ['dashboard','support','jobs'],
  finance:     ['dashboard','payments','reports'],
  analytics:   ['dashboard','analytics','reports'],
};
const ROLE_LABELS = {
  superadmin:'Super Admin', moderator:'Moderator', maintenance:'Maintenance',
  support:'Support', finance:'Finance', analytics:'Analytics',
};

// Set this to your real Shopify store domain (e.g. "your-store.myshopify.com")
// so the "View in Shopify" links in ProductsPage resolve correctly.
// Leave blank/undefined if you don't want those links to render.
const SHOPIFY_STORE_DOMAIN = process.env.REACT_APP_SHOPIFY_STORE_DOMAIN || '';

export default function AdminDashboard() {
  const navigate = useNavigate();

  // ── State ─────────────────────────────────────────────
  const [pendingCraftsmen,  setPendingCraftsmen]  = useState([]);
  const [approvedCraftsmen, setApprovedCraftsmen] = useState([]);
  const [loading,           setLoading]           = useState(true);
  const [error,             setError]             = useState('');
  const [pendingFilter,     setPendingFilter]     = useState('');
  const [approvedFilter,    setApprovedFilter]    = useState('');
  const [activeSection,     setActiveSection]     = useState('dashboard');
  const [craftsmenSub,      setCraftsmenSub]      = useState('pending');
  const [jobs,              setJobs]              = useState([]);
  const [jobsLoading,       setJobsLoading]       = useState(false);
  const [showRejectModal,   setShowRejectModal]   = useState(false);
  const [rejectReason,      setRejectReason]      = useState('');
  const [rejectTarget,      setRejectTarget]      = useState(null);
  const [selectedCraftsmen, setSelectedCraftsmen] = useState({});
  const [editingCraftsman,  setEditingCraftsman]  = useState(null);
  const [editForm,          setEditForm]          = useState({});
  const [adminName,         setAdminName]         = useState('');
  const [adminEmail,        setAdminEmail]        = useState('');
  const [adminRole,         setAdminRole]         = useState('superadmin');
  const [showDrop,          setShowDrop]          = useState(false);
  const [collapsed,         setCollapsed]         = useState(false);
  const [mobileOpen,        setMobileOpen]        = useState(false);
  const [recentActivity,    setRecentActivity]    = useState([]);

  const [viewingCraftsman, setViewingCraftsman] = useState(null);

  // Only used here for badge counts (sidebar badge, dashboard stat card, quick-actions
  // button). The actual Products page (pending/approved/rejected/security) is rendered
  // by <ProductsPage />, which does its own fetching per tab.
  const [pendingProductsCount, setPendingProductsCount] = useState(0);

  const isMob      = () => window.innerWidth < 768;
  const canAccess  = useCallback((sec) => (ROLE_PERMISSIONS[adminRole] || []).includes(sec), [adminRole]);
  const getImgSafe = (p) => getFullImageUrl(p);

  useEffect(() => {
    const fn = () => { if (window.innerWidth < 768) setCollapsed(false); };
    fn(); window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  const isCraftsmanApproved = (c) => c?.is_approved === true;
  const checkCriteria = (c) => {
    const e = [];
    if (!c.full_name?.trim())   e.push('Full name missing');
    if (!c.profile)             e.push('Profile photo missing');
    if (!c.profession?.trim())  e.push('Profession missing');
    if (!c.description?.trim()) e.push('Description missing');
    if (!c.primary_service?.trim() && !c.services?.[0]?.name?.trim()) e.push('Service required');
    if (!Array.isArray(c.gallery_images) || !c.gallery_images.length) e.push('Work photo required');
    return e;
  };

  const statusLabelFor = (c) => {
    if (!isCraftsmanApproved(c)) return "Rejected";
    if (c.is_suspended) return "Suspended";
    return c.is_active ? "Active" : "Inactive";
  };

  const autoApprovePending = async (list) => {
    const ready = list.filter(c => checkCriteria(c).length === 0);
    if (!ready.length) return;
    await Promise.allSettled(ready.map(c => api.post(`admin/craftsman/${c.id}/approve/`, {})));
    await fetchCraftsmen(false);
  };

  const fetchAdminProfile = async () => {
    try {
      const { data } = await api.get('admin/profile/');
      setAdminName(data.full_name || data.name || 'Admin');
      setAdminEmail(data.email || '');
      setAdminRole(data.role || 'superadmin');
    } catch {
      setAdminName('Admin');
    }
  };

  const fetchCraftsmen = async (runAuto = true) => {
    setLoading(true);
    try {
      const { data } = await api.get('admin/craftsman/');
      const all = Array.isArray(data) ? data : [];
      const p = all.filter(c => !isCraftsmanApproved(c));
      const a = all.filter(isCraftsmanApproved);
      setPendingCraftsmen(p);
      setApprovedCraftsmen(a);
      setError('');
      if (runAuto) await autoApprovePending(p);

      if (viewingCraftsman) {
        const fresh = all.find(c => c.id === viewingCraftsman.id);
        if (fresh) setViewingCraftsman(fresh);
      }
    } catch {
      setError('Unable to load craftsmen. Check your connection and try refreshing.');
    } finally {
      setLoading(false);
    }
  };

  // Lightweight — only fetches the count of pending products for badges.
  // ProductsPage handles its own full pending/approved/rejected fetching internally.
  const fetchPendingProductsCount = useCallback(async () => {
    try {
      const { data } = await api.get('admin/products/?is_approved=false&status=pending');
      const all = Array.isArray(data) ? data : data.results || [];
      setPendingProductsCount(all.length);
    } catch {
      // Non-fatal — badge just won't update this cycle.
    }
  }, []);

  const buildActivity = (craftsmen, jobsList) => {
    const items = [];
    craftsmen.slice(0, 3).forEach(c => items.push({
      type: 'craftsman', icon: <FaHardHat/>, iconColor: '#fff000',
      label: `${c.full_name} applied as craftsman`,
      tag: 'Pending', tagColor: '#fff000', time: 'Recently',
    }));
    jobsList.slice(0, 3).forEach(j => items.push({
      type: 'job', icon: <FaClipboardList/>, iconColor: '#ffffff',
      label: `Job #${j.id}: ${j.service} — ${j.name || 'client'}`,
      tag: j.status, tagColor: j.status === 'Completed' ? '#fff000' : '#ffffff',
      time: j.schedule ? new Date(j.schedule).toLocaleDateString() : 'Recently',
    }));
    return items.slice(0, 8);
  };

  useEffect(() => { fetchCraftsmen(); fetchAdminProfile(); fetchPendingProductsCount(); }, []);

  const fetchAllJobs = useCallback(async () => {
    setJobsLoading(true);
    try {
      const { data } = await api.get('/job-requests/');
      const list = data || [];
      setJobs(list);
      setRecentActivity(buildActivity(pendingCraftsmen, list));
    } catch {}
    finally { setJobsLoading(false); }
  }, [pendingCraftsmen]);

  useEffect(() => {
    if (['jobs', 'payments', 'dashboard'].includes(activeSection)) fetchAllJobs();
  }, [activeSection]);

  // Refresh the pending-products badge whenever the admin visits/leaves the Products tab
  useEffect(() => {
    fetchPendingProductsCount();
  }, [activeSection, fetchPendingProductsCount]);

  useEffect(() => {
    setRecentActivity(buildActivity(pendingCraftsmen, jobs));
  }, [pendingCraftsmen, jobs]);

  const jobsReady     = jobs.filter(j => j.status === 'Completed');
  const totalRevenue  = jobs.filter(j => /paid/i.test(j.status || '')).reduce((a, j) => a + (Number(j.budget) || 0), 0);
  const activeJobsLen = jobs.filter(j => ['accepted','in_progress','inprogress','quote approved'].some(s => (j.status || '').toLowerCase().includes(s))).length;

  const handleAction = async (type, id, model, craftsman = null, reason = null) => {
    if (model === 'craftsman' && type === 'approve' && craftsman) {
      const errs = checkCriteria(craftsman);
      if (errs.length) { alert('Cannot approve:\n• ' + errs.join('\n• ')); return; }
    }
    try {
      await api.post(`admin/${model}/${id}/${type}/`, reason ? { reason } : {});
      await fetchCraftsmen(false);
    } catch { alert(`Action failed: ${type}`); }
  };

  const openRejectModal = (c) => { setRejectTarget({ id: c.id, model: 'craftsman' }); setRejectReason(''); setShowRejectModal(true); };
  const confirmReject   = async () => {
    if (!rejectReason.trim()) { alert('Please provide a reason.'); return; }
    await handleAction('reject', rejectTarget.id, rejectTarget.model, null, rejectReason);
    setShowRejectModal(false);
    setViewingCraftsman(null);
  };

  const toggleActive = async (c) => {
    try { await api.patch(`admin/craftsman/${c.id}/toggle-active/`); fetchCraftsmen(false); }
    catch { alert('Failed to update status.'); }
  };

  const openEditModal = (c) => {
    setEditingCraftsman(c);
    setEditForm({ full_name: c.full_name || '', profession: c.profession || '', description: c.description || '', primary_service: c.primary_service || '' });
  };

  const saveEdit = async () => {
    if (!editingCraftsman) return;
    try { await api.patch(`admin/craftsman/${editingCraftsman.id}/`, editForm); setEditingCraftsman(null); fetchCraftsmen(false); }
    catch { alert('Save failed. Please try again.'); }
  };

  const processPayment = async (id) => {
    try { await api.post(`/job-requests/${id}/pay/`); fetchAllJobs(); }
    catch { alert('Payment processing failed. Please try again.'); }
  };

  const handleApproveFromDetail = async (c) => {
    await handleAction('approve', c.id, 'craftsman', c);
  };
  const handleRejectFromDetail = (c) => {
    openRejectModal(c);
  };
  const handleSuspendFromDetail = async (c) => {
    await toggleActive(c);
  };
  const handleDeleteFromDetail = async (c) => {
    if (!window.confirm(`Permanently delete ${c.full_name || 'this craftsman'}? This cannot be undone.`)) return;
    try {
      await api.delete(`admin/craftsman/${c.id}/`);
      setViewingCraftsman(null);
      fetchCraftsmen(false);
    } catch {
      alert('Delete failed. Your backend may not yet have a DELETE endpoint at admin/craftsman/{id}/ — add one to enable this.');
    }
  };
  const handleSaveNotes = async (id, notes) => {
    try {
      await api.patch(`admin/craftsman/${id}/`, { admin_notes: notes });
      fetchCraftsmen(false);
    } catch {
      alert('Saving notes failed. Your backend may need an admin_notes field added to the Craftsman model/serializer.');
    }
  };

  const handleLogout = async () => {
    if (!window.confirm('Are you sure you want to log out?')) return;
    try { await api.post('/logout/'); } catch {}
    navigate('/admin-login');
  };

  const navTo = (sec, sub = null) => {
    if (!canAccess(sec)) return;
    setActiveSection(sec);
    if (sub) setCraftsmenSub(sub);
    setViewingCraftsman(null);
    if (isMob()) setMobileOpen(false);
    setShowDrop(false);
  };

  const getTitle = () => {
    if (activeSection === 'dashboard') return { main: 'Dashboard', rest: 'Overview' };
    if (activeSection === 'craftsmen') {
      if (viewingCraftsman) return { main: viewingCraftsman.full_name || 'Craftsman', rest: 'Detail' };
      const m = { pending: 'Pending', approved: 'Active', inactive: 'Inactive' };
      return { main: m[craftsmenSub], rest: 'Craftsmen' };
    }
    if (activeSection === 'products') return { main: 'Product', rest: 'Approvals' };
    const map = { jobs: 'Job', payments: 'Payment', reports: 'Reports', analytics: 'Analytics', support: 'Support', settings: 'Settings' };
    const rest = activeSection === 'jobs' ? 'Management' : activeSection === 'payments' ? 'Management' : '';
    return { main: map[activeSection] || activeSection, rest };
  };
  const { main: ptMain, rest: ptRest } = getTitle();

  const stats = [
    { lbl:'Pending Approvals', val:pendingCraftsmen.length,  accent:'#fff000', iconBg:'rgba(255,240,0,.08)',  ic:<FaClipboardList/>, delta:'+2 today', deltaUp:true,  sec:'craftsmen', sub:'pending' },
    { lbl:'Active Craftsmen',  val:approvedCraftsmen.filter(c=>c.is_active).length, accent:'#ffffff', iconBg:'rgba(255,255,255,.08)', ic:<FaCheckCircle/>, delta:'on platform', sec:'craftsmen', sub:'approved' },
    { lbl:'Total Jobs',        val:jobs.length, accent:'#ffffff', iconBg:'rgba(255,255,255,.06)', ic:<FaClipboardList/>, delta:`${activeJobsLen} active`, sec:'jobs' },
    { lbl:'Ready to Pay',      val:jobsReady.length, accent:'#fff000', iconBg:'rgba(255,240,0,.08)', ic:<FaDollarSign/>, delta:'awaiting payout', sec:'payments' },
    { lbl:'Pending Products',  val:pendingProductsCount, accent:'#e6d900', iconBg:'rgba(230,217,0,.08)', ic:<FaBox/>, delta:'awaiting review', sec:'products' },
    { lbl:'Revenue (KSh)',     val:`${(totalRevenue/1000).toFixed(1)}k`, accent:'#fff000', iconBg:'rgba(255,240,0,.08)', ic:<FaDollarSign/>, delta:'paid jobs total', sec:'payments' },
  ];

  const sbClass = `sb${collapsed ? ' col' : ''}${isMob() ? (mobileOpen ? ' ms' : ' mh') : ''}`;
  const mnClass = `mn${collapsed ? ' col' : ''}`;

  const showCraftsmen = canAccess('craftsmen');
  const showJobs      = canAccess('jobs');
  const showPayments  = canAccess('payments');
  const showReports   = canAccess('reports');
  const showAnalytics = canAccess('analytics');
  const showSupport   = canAccess('support');
  const showSettings  = canAccess('settings');
  const showProducts  = canAccess('products');

  const currentCraftsmenList =
    craftsmenSub === 'pending'  ? pendingCraftsmen :
    craftsmenSub === 'approved' ? approvedCraftsmen :
    approvedCraftsmen.filter(c => !c.is_active);

  return (
    <div className="adm">
      <style>{THEME}</style>

      {mobileOpen && <div className="mob-overlay" onClick={() => setMobileOpen(false)}/>}

      {/* ════════════ SIDEBAR ════════════ */}
      <aside className={sbClass}>
        <div className="sb-logo">
          <div className="sb-gem">
            <img src={kaakaziniLogo} alt="Kaakazini" />
          </div>
          <span className="sb-brand">Kaa<em>Kazini</em></span>
        </div>

        <nav className="sb-nav">
          <button className={`sb-btn${activeSection === 'dashboard' ? ' on' : ''}`} onClick={() => navTo('dashboard')}>
            <FaHome className="sb-ic"/><span className="sb-lbl">Dashboard</span>
          </button>

          {showCraftsmen && (<>
            <div className="sb-section">Craftsmen</div>
            {[
              { key: 'pending',  lbl: 'Pending',  Icon: FaClipboardList, badge: pendingCraftsmen.length },
              { key: 'approved', lbl: 'Active',   Icon: FaCheckCircle },
              { key: 'inactive', lbl: 'Inactive', Icon: FaToggleOff },
            ].map(({ key, lbl, Icon, badge }) => (
              <button key={key} className={`sb-btn${activeSection === 'craftsmen' && craftsmenSub === key ? ' on' : ''}`}
                onClick={() => navTo('craftsmen', key)} style={{ paddingLeft: '.9rem' }}>
                <Icon className="sb-ic"/><span className="sb-lbl">{lbl}</span>
                {badge > 0 && <span className="sb-badge">{badge}</span>}
              </button>
            ))}
          </>)}

          <div className="sb-section">Management</div>
          {showJobs      && <button className={`sb-btn${activeSection === 'jobs' ? ' on' : ''}`}      onClick={() => navTo('jobs')}><FaClipboardList className="sb-ic"/><span className="sb-lbl">Jobs</span></button>}
          {showPayments  && <button className={`sb-btn${activeSection === 'payments' ? ' on' : ''}`}  onClick={() => navTo('payments')}><FaDollarSign className="sb-ic"/><span className="sb-lbl">Payments</span>{jobsReady.length > 0 && <span className="sb-badge">{jobsReady.length}</span>}</button>}
          {showProducts  && (
            <button className={`sb-btn${activeSection === 'products' ? ' on' : ''}`} onClick={() => navTo('products')}>
              <FaBox className="sb-ic"/>
              <span className="sb-lbl">Products</span>
              {pendingProductsCount > 0 && <span className="sb-badge">{pendingProductsCount}</span>}
            </button>
          )}
          {showReports   && <button className={`sb-btn${activeSection === 'reports' ? ' on' : ''}`}   onClick={() => navTo('reports')}><FaFileAlt className="sb-ic"/><span className="sb-lbl">Reports</span></button>}
          {showAnalytics && <button className={`sb-btn${activeSection === 'analytics' ? ' on' : ''}`} onClick={() => navTo('analytics')}><FaChartLine className="sb-ic"/><span className="sb-lbl">Analytics</span></button>}

          <div className="sb-section">System</div>
          {showSupport  && <button className={`sb-btn${activeSection === 'support' ? ' on' : ''}`}  onClick={() => navTo('support')}><FaHeadset className="sb-ic"/><span className="sb-lbl">Support</span></button>}
          {showSettings && <button className={`sb-btn${activeSection === 'settings' ? ' on' : ''}`} onClick={() => navTo('settings')}><FaCog className="sb-ic"/><span className="sb-lbl">Settings</span></button>}
        </nav>

        <div className="sb-foot">
          <div className="sb-av">{(adminName.charAt(0) || 'A').toUpperCase()}</div>
          <div className="sb-info">
            <div className="sb-name">{adminName}</div>
            <div className="sb-role"><span className={`rpill rpill-${adminRole}`}>{ROLE_LABELS[adminRole] || adminRole}</span></div>
          </div>
          <button className="sb-logout" onClick={handleLogout} title="Log out"><FaSignOutAlt/></button>
        </div>
      </aside>

      {/* ════════════ MAIN ════════════ */}
      <div className={mnClass}>

        <header className="tb">
          <button className="tb-toggle" onClick={() => isMob() ? setMobileOpen(o => !o) : setCollapsed(c => !c)}>
            {mobileOpen ? <FaTimes size={13}/> : <FaBars size={13}/>}
          </button>

          <div className="tb-title"><em>{ptMain}</em>{ptRest ? ` ${ptRest}` : ''}</div>

          <div className="tb-actions">
            <div className="tb-bell">
              <FaBell size={13}/>
              {(jobsReady.length > 0 || pendingCraftsmen.length > 0 || pendingProductsCount > 0) && <span className="tb-bell-dot"/>}
            </div>

            <div className="position-relative">
              <div className="tb-user" onClick={() => setShowDrop(d => !d)}>
                <div className="tb-user-av">{(adminName.charAt(0) || 'A').toUpperCase()}</div>
                <span className="tb-user-name d-none d-sm-block">{adminName}</span>
                <FaChevronDown size={9} style={{ color: 'var(--txt3)', marginLeft: 2 }}/>
              </div>

              {showDrop && (<>
                <div style={{ position: 'fixed', inset: 0, zIndex: 9996 }} onClick={() => setShowDrop(false)}/>
                <div className="ddrop">
                  <div className="ddrop-head">
                    <div className="ddn">{adminName}</div>
                    <div className="dde">{adminEmail}</div>
                    <div style={{ marginTop: 5 }}><span className={`rpill rpill-${adminRole}`}>{ROLE_LABELS[adminRole]}</span></div>
                  </div>
                  {showSettings && <button className="ddrop-item" onClick={() => { navTo('settings'); setShowDrop(false); }}><FaCog size={12}/> Settings</button>}
                  <button className="ddrop-item" onClick={() => setShowDrop(false)}><FaQuestionCircle size={12}/> Help</button>
                  <hr className="ddrop-div"/>
                  <button className="ddrop-item danger" onClick={handleLogout}><FaSignOutAlt size={12}/> Log out</button>
                </div>
              </>)}
            </div>
          </div>
        </header>

        <main className="ct">

          {loading && (
            <div style={{ textAlign: 'center', padding: '5rem 2rem' }}>
              <div className="spinner-border" style={{ color: '#fff000', width: '2.5rem', height: '2.5rem' }} role="status"/>
              <p style={{ marginTop: '1rem', color: 'var(--txt3)', fontSize: '.88rem' }}>Loading dashboard…</p>
            </div>
          )}

          {error && !loading && (
            <div className="errbanner">
              <FaExclamationTriangle/>
              <span>{error}</span>
              <button onClick={() => fetchCraftsmen()} style={{ marginLeft: 'auto', background: 'rgba(255,255,255,.1)', border: '1px solid rgba(255,255,255,.25)', color: '#ffffff', borderRadius: 7, padding: '3px 10px', cursor: 'pointer', fontSize: '.78rem', fontWeight: 700 }}>
                Retry
              </button>
            </div>
          )}

          {!loading && (
            <>
              {/* ── DASHBOARD ── */}
              {activeSection === 'dashboard' && (
                <>
                  <div className="pg-head">
                    <h1 className="pg-title"><em>Dashboard</em> Overview</h1>
                    <p className="pg-sub">Welcome back, {adminName}. Here's your platform at a glance.</p>
                  </div>

                  <div className="stat-grid">
                    {stats.map((s, i) => (
                      <div key={i} className="stat-card"
                        style={{ '--card-accent': s.accent, '--card-icon-bg': s.iconBg }}
                        onClick={() => s.sec && navTo(s.sec, s.sub)}>
                        <div>
                          <div className="sc-label">{s.lbl}</div>
                          <div className="sc-val">{s.val}</div>
                          {s.delta && <div className={`sc-delta${s.deltaUp ? ' up' : ''}`}>{s.deltaUp ? '▲ ' : ''}{s.delta}</div>}
                        </div>
                        <div className="sc-icon">{s.ic}</div>
                      </div>
                    ))}
                  </div>

                  <div className="row g-3">
                    <div className="col-12 col-lg-8">
                      <div className="glass">
                        <div className="glass-h">
                          <span className="glass-t">Recent Activity</span>
                          <span style={{ fontSize: '.7rem', color: 'var(--gld)', display: 'flex', alignItems: 'center', gap: 5 }}>
                            <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--gld)', display: 'inline-block', animation: 'pulse-dot 2s infinite' }}/>Live
                          </span>
                        </div>
                        <div style={{ padding: '0 1.375rem' }}>
                          {recentActivity.length === 0
                            ? <p style={{ color: 'var(--txt3)', fontSize: '.84rem', padding: '1.25rem 0' }}>No recent activity to display.</p>
                            : recentActivity.map((a, i) => (
                              <div key={i} className="act-row">
                                <div className="act-dot" style={{ background: `${a.iconColor}14`, color: a.iconColor }}>{a.icon}</div>
                                <div style={{ flex: 1 }}>
                                  <div className="act-label">
                                    {a.label}
                                    <span className="act-chip" style={{ background: `${a.tagColor}18`, color: a.tagColor }}>{a.tag}</span>
                                  </div>
                                  <div className="act-time">{a.time}</div>
                                </div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-4">
                      <div className="glass mb-3">
                        <div className="glass-h"><span className="glass-t">Quick Actions</span></div>
                        <div className="glass-b" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                          {canAccess('craftsmen') && <button className="qa-btn" onClick={() => navTo('craftsmen','pending')}><FaShieldAlt style={{ color: '#fff000' }}/> Review Pending ({pendingCraftsmen.length})</button>}
                          {canAccess('products')  && <button className="qa-btn" onClick={() => navTo('products')}><FaBox style={{ color: '#e6d900' }}/> Review Products ({pendingProductsCount})</button>}
                          {canAccess('payments')  && <button className="qa-btn" onClick={() => navTo('payments')}><FaDollarSign style={{ color: '#ffffff' }}/> Process Payments ({jobsReady.length})</button>}
                          {canAccess('jobs')      && <button className="qa-btn" onClick={() => navTo('jobs')}><FaHardHat style={{ color: '#ffffff' }}/> Manage Jobs ({jobs.length})</button>}
                          {canAccess('support')   && <button className="qa-btn" onClick={() => navTo('support')}><FaHeadset style={{ color: '#fff000' }}/> Support Tickets</button>}
                          {canAccess('settings')  && <button className="qa-btn" onClick={() => navTo('settings')}><FaUserCog style={{ color: '#ffffff' }}/> Manage Staff</button>}
                        </div>
                      </div>

                      <div className="glass">
                        <div className="glass-h"><span className="glass-t">Revenue Snapshot</span></div>
                        <div className="glass-b">
                          {[
                            { lbl: 'Total Processed', val: `KSh ${totalRevenue.toLocaleString()}`, c: '#fff000' },
                            { lbl: 'Platform Cut (10%)', val: `KSh ${Math.round(totalRevenue * .1).toLocaleString()}`, c: '#fff000' },
                            { lbl: 'To Craftsmen (90%)', val: `KSh ${Math.round(totalRevenue * .9).toLocaleString()}`, c: 'var(--txt)' },
                          ].map((r, i) => (
                            <div key={i} className="rev-row">
                              <span style={{ fontSize: '.78rem', color: 'var(--txt3)' }}>{r.lbl}</span>
                              <span style={{ fontSize: '.86rem', fontWeight: 700, color: r.c }}>{r.val}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* ── CRAFTSMEN: table or detail view ── */}
              {activeSection === 'craftsmen' && canAccess('craftsmen') && (
                viewingCraftsman ? (
                  <CraftsmandetailViewPage
                    craftsman={viewingCraftsman}
                    isPending={craftsmenSub === 'pending'}
                    getImageUrl={getImgSafe}
                    checkCraftsmanApprovalCriteria={checkCriteria}
                    isCraftsmanApproved={isCraftsmanApproved}
                    onBack={() => setViewingCraftsman(null)}
                    onApprove={handleApproveFromDetail}
                    onReject={handleRejectFromDetail}
                    onEdit={openEditModal}
                    onSuspend={handleSuspendFromDetail}
                    onDelete={handleDeleteFromDetail}
                    onSaveNotes={handleSaveNotes}
                  />
                ) : (
                  <>
                    <div className="pg-head">
                      <h1 className="pg-title"><em>{ptMain}</em> {ptRest}</h1>
                      <p className="pg-sub">Review, approve and manage craftsman profiles</p>
                    </div>
                    {craftsmenSub === 'pending' && (
                      <div className="infobanner">
                        <FaCheckCircle style={{ flexShrink: 0 }}/>
                        <div><strong>Auto-approve enabled.</strong> Craftsmen meeting all criteria are approved automatically on load. Click "View" to see exactly what's missing for any pending craftsman.</div>
                      </div>
                    )}
                    <CraftsmenTable
                      list={currentCraftsmenList}
                      filterValue={craftsmenSub === 'pending' ? pendingFilter : approvedFilter}
                      setFilterValue={craftsmenSub === 'pending' ? setPendingFilter : setApprovedFilter}
                      isPending={craftsmenSub === 'pending'}
                      getImageUrl={getImgSafe}
                      isCraftsmanApproved={isCraftsmanApproved}
                      statusLabelFor={craftsmenSub !== 'pending' ? statusLabelFor : undefined}
                      onView={setViewingCraftsman}
                    />
                  </>
                )
              )}

              {/* ── JOBS ── */}
              {activeSection === 'jobs' && canAccess('jobs') && (
                <>
                  <div className="pg-head">
                    <h1 className="pg-title"><em>Job</em> Management</h1>
                    <p className="pg-sub">View, filter and assign all service requests to craftsmen</p>
                  </div>
                  <JobRequests
                    jobs={jobs} jobsLoading={jobsLoading}
                    approvedCraftsmen={approvedCraftsmen}
                    selectedCraftsmen={selectedCraftsmen}
                    setSelectedCraftsmen={setSelectedCraftsmen}
                    onSuccessAssign={fetchAllJobs}
                  />
                </>
              )}

              {/* ── PAYMENTS ── */}
              {activeSection === 'payments' && canAccess('payments') && (
                <>
                  <div className="pg-head">
                    <h1 className="pg-title"><em>Payment</em> Management</h1>
                    <p className="pg-sub">Process M-Pesa payouts for completed jobs</p>
                  </div>
                  <PaymentDashboard jobsReadyForPayment={jobsReady} processPayment={processPayment}/>
                </>
              )}

              {/* ── PRODUCTS ──
                  Now renders the full ProductsPage component: Pending / Approved /
                  Rejected / Security tabs, grid + table views, search, sort, bulk
                  approve, detail drawer, and Shopify sync status. This replaces
                  the old inline "pending only" grid, which is why the products
                  section used to go permanently empty once nothing was pending. */}
              {activeSection === 'products' && canAccess('products') && (
                <>
                  <div className="pg-head">
                    <h1 className="pg-title"><em>Product</em> Approvals</h1>
                    <p className="pg-sub">Review, approve and manage craftsman products across every status</p>
                  </div>
                  <ProductPage
                    adminRole={adminRole}
                    shopifyStoreDomain={SHOPIFY_STORE_DOMAIN}
                    onChange={fetchPendingProductsCount}
                  />
                </>
              )}

              {/* ── ANALYTICS ── */}
              {activeSection === 'analytics' && canAccess('analytics') && (
                <>
                  <div className="pg-head">
                    <h1 className="pg-title"><em>Analytics</em></h1>
                    <p className="pg-sub">Platform performance, trends and key metrics</p>
                  </div>
                  <AnalyticsPage jobs={jobs} craftsmen={approvedCraftsmen}/>
                </>
              )}

              {/* ── REPORTS ── */}
              {activeSection === 'reports' && canAccess('reports') && (
                <>
                  <div className="pg-head">
                    <h1 className="pg-title"><em>Reports</em></h1>
                    <p className="pg-sub">Export platform data as CSV for Excel / Sheets</p>
                  </div>
                  <ReportsPage jobs={jobs} craftsmen={approvedCraftsmen}/>
                </>
              )}

              {/* ── SUPPORT ── */}
              {activeSection === 'support' && canAccess('support') && (
                <>
                  <div className="pg-head">
                    <h1 className="pg-title"><em>Support</em> Centre</h1>
                    <p className="pg-sub">Handle disputes, complaints and help requests</p>
                  </div>
                  <SupportPage/>
                </>
              )}

              {/* ── SETTINGS ── */}
              {activeSection === 'settings' && canAccess('settings') && (
                <>
                  <div className="pg-head">
                    <h1 className="pg-title"><em>Settings</em></h1>
                    <p className="pg-sub">Staff management, services, locations and system config</p>
                  </div>
                  <SettingsPage adminRole={adminRole}/>
                </>
              )}

              {/* ── ACCESS DENIED ── */}
              {!canAccess(activeSection) && activeSection !== 'dashboard' && (
                <div className="glass access-denied">
                  <div className="lock-icon">🔒</div>
                  <h4>Access Restricted</h4>
                  <p>Your role (<strong>{ROLE_LABELS[adminRole]}</strong>) does not have access to this section.</p>
                </div>
              )}
            </>
          )}
        </main>
      </div>

      {/* ════════════ EDIT MODAL ════════════ */}
      {editingCraftsman && (<>
        <div className="modal-overlay" onClick={() => setEditingCraftsman(null)}/>
        <div className="modal-box">
          <div className="modal-head">
            <span className="modal-head-title"><FaEdit style={{ color: '#fff000' }}/> Edit Craftsman</span>
            <button className="modal-close" onClick={() => setEditingCraftsman(null)}>✕</button>
          </div>
          <div className="modal-body">
            {[
              ['Full Name', 'full_name', 'input'],
              ['Profession', 'profession', 'input'],
              ['Description', 'description', 'textarea'],
              ['Primary Service', 'primary_service', 'input'],
            ].map(([lbl, key, type]) => (
              <div key={key}>
                <label className="mlabel">{lbl}</label>
                {type === 'textarea'
                  ? <textarea rows={3} value={editForm[key]} onChange={e => setEditForm({ ...editForm, [key]: e.target.value })} className="minp" style={{ resize: 'vertical' }}/>
                  : <input value={editForm[key]} onChange={e => setEditForm({ ...editForm, [key]: e.target.value })} className="minp"/>
                }
              </div>
            ))}
          </div>
          <div className="modal-foot">
            <button onClick={() => setEditingCraftsman(null)} style={{ padding: '.6rem 1.1rem', background: 'rgba(255,255,255,.06)', border: '1px solid var(--bdr2)', borderRadius: 9, color: 'var(--txt2)', cursor: 'pointer', fontWeight: 600, fontSize: '.84rem' }}>Cancel</button>
            <button onClick={saveEdit} className="btn-gld"><FaCheckCircle size={12}/> Save Changes</button>
          </div>
        </div>
      </>)}

      {/* ════════════ REJECT MODAL ════════════ */}
      <RejectModal
        show={showRejectModal}
        rejectReason={rejectReason}
        setRejectReason={setRejectReason}
        confirmReject={confirmReject}
        closeModal={() => setShowRejectModal(false)}
      />

      <style>{`@keyframes pulse-dot { 0%,100%{opacity:1} 50%{opacity:.4} }`}</style>
    </div>
  );
}